import React from 'react';
import {Card, Button} from 'react-bootstrap';
import {Link} from "react-router-dom";  
import './Home.css';

const MainDisplay = ({productImage, productName, description, price}) => {
    return ( 
      <div> 
      <Card style={{ width: '14rem' }} className="items">
        <Card.Img variant="top" src={productImage}/>
         <Card.Body>
          <Card.Title>Name: {productName}</Card.Title>
            <Card.Text>
            Description: {description}
            </Card.Text>
            <Card.Title>Price: Call Us {price}</Card.Title>
            <Link to="/contact"><Button variant="primary" >Contact Us</Button></Link>
         </Card.Body>
      </Card>
        
      </div>  
     );
}
 
export default MainDisplay;